var link_viewer_default = {
  "fontElementMap": "slWwD",
  "link": "zN7XU",
  "linkInEditor": "_4X7um",
  "linkInViewer": "AP91R",
  "toolbarUrlContainer": "_7qjtp",
  "toolbarUrl": "mmFEi",
  "toolbarUrlAnchor": "DGN4K"
};
export {
  link_viewer_default as default
};
//# sourceMappingURL=link-viewer-scss.js.map
